export class DownloadQuarterlyExport {
    static readonly type = '[Quarterly Export] Download';
}

export class ClearQuarterlyExportDownloadLink {
    static readonly type = '[Quarterly Export] Clear Download Link';
}
